/**
 * @param formData {unknown}
 * @return {string}
 */
module.exports = function formsAtIterableComFormSubmissionMessage(formData) {
    return JSON.stringify(formData, null, 2);
}